export default "__VITE_ASSET__D70E9zH2__"